export default __webpack_public_path__ + "static/hpc_20220103_1200-725fdc4511a7ca4a536470be52135a47.jpg";